const isInitialised = (property) => (state) => state.getIn(['app', 'initialised', property]);

export const isCurrentUserInitialised = isInitialised('currentUser');
export const areRemoteUsersInitialised = isInitialised('remoteUsers');
export const areAliasesInitialised = isInitialised('aliases');
export const areElementCountsInitialised = isInitialised('elementCounts');
export const areBoardSummariesInitialised = isInitialised('boardSummaries');
export const areBoardHierarchiesInitialised = isInitialised('boardHierarchies');
export const isSocketConnectionInitialised = isInitialised('socketConnection');
export const areCustomTemplatesInitialised = isInitialised('customTemplates');
export const isAppInitCompleted = isInitialised('appInit');

export const getPageLoadTime = (state) => state.getIn(['app', 'initialised', 'pageLoadTime']);
export const getWorkspaceLoadIdleTime = (state) => state.getIn(['app', 'initialised', 'workspaceLoadIdleTime']);
